import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
    TextField,
    IconButton,
    Typography,
    Alert,
    Tooltip,

} from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import CustomSelect from './CustomSelect';
import { api } from '../helpers/apiRequest';
import colors from '../theme/Colors';
import dayjs from 'dayjs';
import PackingItemsTable from './PackingItemsTable'
import { toast } from 'react-toastify';
import ManagementDialog from './ManagementDialog';
const AddPackingListModal = ({ open, onClose, onSubmit, editData }) => {
    console.log("editData:",editData);
    const sizes=['XS','S', 'M', 'L', 'XL', '2XL','3XL', 'MIX'];
    const defaultItem = {
        p_style: '',
        style: '',
        item: '',
        color: '',
        order_no:'',
        sizes: [],
        total_pieces: 0,
        per_box: null,
        total_box: 0
    };

    const [formData, setFormData] = useState([
        {
            customer: '',
            party: '',
            lot: '',
            
            container: '',
            ex_factory: null,
            ship_date: null,
            arrival: null,
            items: [defaultItem]
        }
    ]);

    const [customers, setCustomers] = useState([]);
    const [parties, setParties] = useState([]);
    const [userInfo] = useState(JSON.parse(localStorage.getItem('user')));
    const [pStyles, setPStyles] = useState([]);
    const [styles, setStyles] = useState([]);
    const [itemsList, setItemsList] = useState([]);
    // new
    const [managementDialogOpen, setManagementDialogOpen] = useState(false);
    const [managementType, setManagementType] = useState('party');
    const [addRecordDialog, setAddRecordDialog] = useState({
        open: false,
        type: '',
        name: '',
        party: '',
        customer: ''
    });
    useEffect(() => { console.log("addRecordDialog:", addRecordDialog) }, [addRecordDialog])
    //   till here
    const [errors, setErrors] = useState({
        customer: '',
        party: '',
        lot: '',
        container: '',
        ex_factory: '',
        ship_date: '',
        arrival: '',
        items: [],
        order_no:''
    });
    const handleOpenAddRecordDialog = async (type) => {
        setAddRecordDialog({
            open: true,
            type,
            name: '',
            party: '',
            customer: ''
        });
        await fetchDropdownData();
    };
    const handleOpenManagementDialog = (type) => {
        if (!formData[0]?.party) {
            toast.warn('Please select a Party to managed its ' + type);
            return;
        }
        setManagementType(type);
        setManagementDialogOpen(true);

    };

    const fetchDropdownData = async (merchantId) => {
        try {
            const endpoint =
                userInfo?.role === 'merchant'
                    ? `inventory/party/merchant/${userInfo?.id}`
                    : `inventory/party`;
            const [customersRes, partiesRes] = await Promise.all([
                // api.get('users/users/role/customer'),
                api.get(`users/merchant/customers/${editData ? editData?.merchant?._id : userInfo?.id}`),
                api.get(endpoint),
            ]);

            setCustomers(customersRes?.data?.data || []);
            console.log('Customers Response:', customers);
            setParties(partiesRes?.data?.message || []);
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    };

    const handleRemoveForm = (index) => {
        setFormData(prev => prev.filter((_, i) => i !== index));
    };

    useEffect(() => {
        if (open) {
            fetchDropdownData();
        }
    }, [open]);
    useEffect(() => {

    }, [customers]);

    useEffect(() => {
        if (editData) {
            const transformedForms = editData?.items?.map((item, index) => ({
                customer: editData?.customer?._id,
                party: editData?.party?._id,
                lot: editData?.lot,
                container: editData?.container,
                
                // ex_factory: !editData?.ex_factory?'':dayjs(editData?.ex_factory),
                // ship_date: !editData?.ship_date?'':dayjs(editData?.ship_date),
                // arrival: !editData?.arrival?'':dayjs(editData?.arrival),
                ex_factory: !editData?.ex_factory ? null : dayjs(editData?.ex_factory),
                ship_date: !editData?.ship_date ? null : dayjs(editData?.ship_date),
                arrival: !editData?.arrival ? null : dayjs(editData?.arrival),
                // Set the common fields for all items in this form
                p_style: item?.p_style?._id,
                style: item?.style?._id,
                item: item?.item?._id,
                // Transform the colors array into the expected items format
                items: item?.colors?.map(colorData => ({
                    p_style: item?.p_style?._id,
                    style: item?.style?._id,
                    item: item?.item?._id,
                    order_no:item?.order_no,
                    color: colorData?.color,
                    sizes: colorData?.sizes,
                    total_pieces: colorData?.sizes?.reduce((sum, size) => sum + size?.quantity, 0),
                    per_box: colorData?.per_box || 0,
                    total_box: colorData?.total_box || Math.ceil(
                        colorData?.sizes?.reduce((sum, size) => sum + size?.quantity, 0) /
                        (colorData?.per_box || 1)
                    )
                }))
            }));

            setFormData(transformedForms);

            // If there's a party ID, fetch dependent data
            if (editData?.party?._id) {
                fetchDependentData(editData?.party?._id);
            }
        }
    }, [editData]);

    const fetchDependentData = async (partyId) => {
        try {
            const [pStylesRes, stylesRes, itemsRes] = await Promise.all([
                api.get(`inventory/pstyles_party?party=${partyId}`),
                api.get(`inventory/styles_party?party=${partyId}`),
                api.get(`inventory/items_party?party=${partyId}`)
            ]);

            setPStyles(pStylesRes?.data?.message || []);
            setStyles(stylesRes?.data?.message || []);
            setItemsList(itemsRes?.data?.message || []);
        } catch (error) {
            console.error('Error fetching dependent data:', error);
        }
    };

    const handleChange = (formIndex, field, value) => {
        setFormData(prev => {
            const newData = [...prev];
            newData[formIndex] = {
                ...newData[formIndex],
                [field]: value
            };
            return newData;
        });

        if (field === 'party' && value) {
            fetchDependentData(value);
        }
    };

    const handleItemChange = (formIndex, itemIndex, field, value) => {
        console.log("formIndex, itemIndex, field, value",{formIndex, itemIndex, field, value});
        setFormData(prev => {
            const newData = [...prev];
            if (itemIndex >= newData[formIndex].items.length) {
                newData[formIndex].items.push({
                    ...defaultItem,
                    p_style: newData[formIndex]?.p_style || '',
                    style: newData[formIndex]?.style || '',
                    item: newData[formIndex]?.item || '',
                    order_no:newData[formIndex]?.order_no||''
                });
            }
            if (!newData[formIndex]?.items[itemIndex]) {
                newData[formIndex].items[itemIndex] = {
                    ...defaultItem,
                    p_style: newData[formIndex]?.p_style || '',
                    style: newData[formIndex]?.style || '',
                    item: newData[formIndex]?.item || '',
                    order_no:newData[formIndex]?.order_no||''

                };
            }
            const item = newData[formIndex].items[itemIndex];

            if (['XS','S', 'M', 'L', 'XL', '2XL','3XL', 'MIX'].includes(field)) {
                // if (sizes.includes(field)) {

                const sizeIndex = item?.sizes?.findIndex(s => s?.size === field);
                const quantity = parseInt(value) || 0;

                if (sizeIndex >= 0) {
                    item.sizes[sizeIndex].quantity = quantity;
                } else if (quantity > 0) {
                    item.sizes.push({ size: field, quantity });
                }

                item.total_pieces = item.sizes.reduce((sum, s) => sum + s.quantity, 0);
                item.total_box = Math.ceil(item.total_pieces / (item.per_box || 1));
            } else if (field === 'per_box') {
                item.per_box = parseInt(value) || 0;
                if (item.per_box > 0) {
                    item.total_box = Math.ceil(item.total_pieces / item.per_box);
                }
            } else if (['p_style', 'style', 'item'].includes(field)) {
                newData[formIndex][field] = value;
                newData[formIndex]?.items?.forEach(item => {
                    item[field] = value;
                });
            } else {
                item[field] = value;
            }
            console.log("newData:",newData);
            return newData;
        });
    };

    const handleRemoveItem = (formIndex, itemIndex) => {
        setFormData(prev => {
            const newData = [...prev];
            // Only remove the item if there's more than one item in the form
            if (newData[formIndex].items.length > 1) {
                newData[formIndex].items = newData[formIndex].items.filter((_, i) => i !== itemIndex);
            }
            return newData;
        });
    };

    const handleAddForm = () => {
        setFormData(prev => [...prev, {
            customer: prev[0].customer,
            party: prev[0].party,
            lot: prev[0].lot,
            container: prev[0].container,
            ex_factory: prev[0].ex_factory,
            ship_date: prev[0].ship_date,
            arrival: prev[0].arrival,
            items: [defaultItem]
        }]);
    };

    const validateForm = () => {
        let isValid = true;
        const newErrors = {
            customer: '',
            party: '',
            lot: '',
            order_no:'',
            container: '',
            ex_factory: '',
            ship_date: '',
            arrival: '',
            items: []
        };

        // Validate main fields
        if (!formData[0].customer) {
            newErrors.customer = 'Customer is required';
            isValid = false;
        }
        if (!formData[0]?.party) {
            toast.error('Party is required');
            newErrors.party = 'Party is required';
            isValid = false;
        }
        if (!formData[0]?.p_style) {
            console.log("!formData[0]?.style", !formData[0]?.p_style);
            toast.error('P-Style is required');
            newErrors.p_style = 'P-Style is required';
            isValid = false;
        }
        // if (!formData[0]?.order_no) {
        //     console.log("!formData[0]?.style", !formData[0]?.p_style);
        //     toast.error('Order No is required');
        //     newErrors.p_style = 'Order No is required';
        //     isValid = false;
        // }
        // if (!formData[0]?.style) {
        //     console.log("!formData[0]?.style", !formData[0]?.style);
        //     toast.error('Style is required');
        //     newErrors.style = 'Style is required';
        //     isValid = false;
        // }
        if (!formData[0]?.item) {
            console.log("!formData[0]?.item:", !formData[0]?.item);
            toast.error('Item is required');
            newErrors.item = 'Item is required';
            isValid = false;
        }
        // shouldn't  be mandatory
        // if (!formData[0].lot) {
        //     newErrors.lot = 'Lot is required';
        //     isValid = false;
        // }
        // if (!formData[0].container) {
        //     newErrors.container = 'Container is required';
        //     isValid = false;
        // }
        // if (!formData[0].ex_factory) {
        //     newErrors.ex_factory = 'Ex-Factory date is required';
        //     isValid = false;
        // }
        // if (!formData[0].ship_date) {
        //     newErrors.ship_date = 'Ship date is required';
        //     isValid = false;
        // }
        // if (!formData[0].arrival) {
        //     newErrors.arrival = 'Arrival date is required';
        //     isValid = false;
        // }

        // Validate dates sequence
        // if (formData[0]?.ex_factory && formData[0].ship_date &&
        //     dayjs(formData[0]?.ex_factory).isAfter(formData[0]?.ship_date)) {
        //     newErrors.ship_date = 'Ship date must be after Ex-Factory date';
        //     isValid = false;
        // }
        // if (formData[0].ship_date && formData[0].arrival &&
        //     dayjs(formData[0].ship_date).isAfter(formData[0].arrival)) {
        //     newErrors.arrival = 'Arrival date must be after Ship date';
        //     isValid = false;
        // }}

        // Validate items
        formData.forEach((form, formIndex) => {
            form.items.forEach((item, itemIndex) => {
                if (!newErrors.items[formIndex]) {
                    newErrors.items[formIndex] = [];
                }
                if (!newErrors.items[formIndex][itemIndex]) {
                    newErrors.items[formIndex][itemIndex] = {};
                }
                if (!item.p_style) {
                    newErrors.items[formIndex][itemIndex].p_style = 'P-Style is required';
                    isValid = false;
                }
                // if (!item.style) {
                //     newErrors.items[formIndex][itemIndex].style = 'Style is required';
                //     isValid = false;
                // }
                if (!item.item) {
                    newErrors.items[formIndex][itemIndex].item = 'Item is required';
                    isValid = false;
                }
                if (!item.color) {
                    newErrors.items[formIndex][itemIndex].color = 'Color is required';
                    isValid = false;
                }
                if (item.sizes.length === 0) {
                    newErrors.items[formIndex][itemIndex].sizes = 'At least one size is required';
                    isValid = false;
                }
                if (item.per_box <= 0) {
                    newErrors.items[formIndex][itemIndex].per_box = 'Pieces per box must be greater than 0';
                    isValid = false;
                }
            });
        });

        console.log("is Valid:", { isValid, newErrors });
        setErrors(newErrors);
        return isValid;
    };

    const resetForm = () => {
        setFormData([{
            customer: '',
            party: '',
            lot: '',
            container: '',
            ex_factory: null,
            ship_date: null,
            arrival: null,
            items: [defaultItem]
        }]);
        setErrors({
            customer: '',
            party: '',
            lot: '',
            container: '',
            ex_factory: '',
            ship_date: '',
            arrival: '',
            items: []
        });
    };

    useEffect(() => {
        if (open && !editData) {
            resetForm();
        }
    }, [open]);
    useEffect(() => {

    }, [addRecordDialog]);
    const handleSubmit = async () => {
        try {
            if (!validateForm()) {
                console.log("im here");
                return;
            }
            const allItems = formData.reduce((acc, form) => {
                return [...acc, ...form.items];
            }, []);

            // Create payload
            const payload = {
                customer: formData[0].customer,
                party: formData[0]?.party,
                order_no:formData[0]?.order_no,
                lot: !formData[0]?.lot ? '' : formData[0]?.lot,
                container: !formData[0]?.container ? '' : formData[0]?.container,
                ex_factory: !formData[0]?.ex_factory ? null : dayjs(formData[0]?.ex_factory)?.format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
                ship_date: !formData[0]?.ship_date ? null : dayjs(formData[0]?.ship_date)?.format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
                arrival: !formData[0]?.arrival ? null : dayjs(formData[0]?.arrival)?.format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
                items: allItems.map((item,index) => ({
                    p_style: item.p_style,
                    // style: item.style,
                    item: item.item,
                    color: item.color,
                    order_no:item?.order_no,
                    sizes: item.sizes.filter(size => size.quantity > 0),
                    total_pieces: item.total_pieces,
                    per_box: item.per_box,
                    total_box: item.total_box
                }))
            };

            await onSubmit(payload);
            resetForm();
            onClose();
        } catch (error) {
            console.error('Error submitting packing list:', error);
        }
    };
    // new
    const handleCloseAddRecordDialog = () => {
        setAddRecordDialog({
            open: false,
            type: '',
            name: '',
            party: '',
            customer: ''
        });
    };

    const handleAddRecord = async () => {
        console.log("!addRecordDialog.name.trim():", !addRecordDialog.name.trim());
        if (!addRecordDialog.name.trim()) {
            toast.warn('Name cannot be empty.');
            return;
        }

        if (addRecordDialog.type === 'party' && !addRecordDialog.customer) {
            toast.warn('Please select a customer.');
            return;
        }

        if (['style', 'pStyle', 'item'].includes(addRecordDialog.type) && !addRecordDialog.party) {
            toast.warn('Please select a party.');
            return;
        }

        try {
            const endpoints = {
                party: 'inventory/party',
                pStyle: 'inventory/p-style',
                style: 'inventory/style',
                item: 'inventory/item'
            };

            let payload;
            if (addRecordDialog.type === 'party') {
                payload = {
                    name: addRecordDialog.name,
                    customer: addRecordDialog.customer
                };
            } else if (['style', 'pStyle', 'item'].includes(addRecordDialog.type)) {
                payload = {
                    name: addRecordDialog.name,
                    party: addRecordDialog.party
                };
            } else {
                payload = {
                    name: addRecordDialog.name
                };
            }

            const response = await api.post(endpoints[addRecordDialog.type], payload);

            if (response.status === 200 || response.OK) {
                toast.success('Added successfully');
                fetchDropdownData();
                fetchDependentData(formData[0]?.party);
                handleCloseAddRecordDialog();
            }
        } catch (error) {
            toast.error('Failed to add record. Please try again.');
            console.error('Error adding record:', error);
        }
    };
    // till here
    return (
        <Dialog
            open={open}
            onClose={() => {
                resetForm();
                onClose();
            }}
            maxWidth="lg"
            fullWidth
        >
            <DialogTitle>{editData ? 'Edit Packing List' : 'Add Packing List'}</DialogTitle>
            <DialogContent
                sx={{
                    pt: 1,
                    pb: 1,
                    '&::-webkit-scrollbar': {
                        width: '8px'
                    },
                    '&::-webkit-scrollbar-thumb': {
                        backgroundColor: '#bdbdbd',
                        borderRadius: '4px'
                    }
                }}>

                <Box sx={{ mb: 3 }}>
                    <CustomSelect
                        label="Customer"
                        value={formData[0].customer}
                        onChange={(e) => handleChange(0, 'customer', e.target.value)}
                        options={customers?.map((c) => ({ id: c?.customer?._id, name: c?.customer?.name })) || []}
                        fullWidth
                        sx={{ minWidth: '100%' }}
                        error={!!errors.customer}
                        helperText={errors.customer}
                    />
                </Box>

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Box sx={{ display: 'block', gap: 1 }} >
                        <Box sx={{ flex: 1, flexDirection: 'row', display: 'flex', position: 'relative' }}>
                            <CustomSelect
                                label="Party"
                                value={formData[0].party}
                                onChange={(e) => handleChange(0, 'party', e.target.value)}
                                options={parties?.map((p) => ({ id: p._id, name: p.name })) || []}
                                fullWidth
                                error={!!errors.party}
                                helperText={errors.party}
                                sx={{
                                    minWidth: '91%',
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: errors.party ? 'error.main' : colors.primary,
                                        },
                                    },

                                }}
                            />
                            {/* new stuff */}
                            <IconButton
                                onClick={() => handleOpenAddRecordDialog('party')}
                                sx={{
                                    marginLeft: 2,
                                    backgroundColor: colors.primary,
                                    '&:hover': { backgroundColor: colors.primary, opacity: 0.9 }
                                }}
                            >
                                <Tooltip title="Add Party">
                                    <AddIcon sx={{ color: 'black', fontSize: 22 }} />
                                </Tooltip>
                            </IconButton>

                            <IconButton
                                onClick={() => handleOpenManagementDialog('party')}
                                sx={{
                                    marginLeft: 1,
                                    backgroundColor: colors.primary,
                                    '&:hover': {
                                        backgroundColor: colors.primary,
                                        opacity: 0.9
                                    }
                                }}
                            >
                                <Tooltip title="Management">
                                    <SettingsIcon sx={{ color: 'black', fontSize: 22 }} />
                                </Tooltip>
                            </IconButton>
                            {/* end new stuff */}
                        </Box>

                        <Box sx={{ flex: 1 }}>
                            <TextField
                                label="Lot"
                                value={formData[0].lot}
                                onChange={(e) => handleChange(0, 'lot', e.target.value)}
                                fullWidth
                                error={!!errors.lot}
                                helperText={errors.lot}
                                sx={{
                                    marginTop: 1,
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: errors.lot ? 'error.main' : colors.primary,
                                        },
                                    },
                                }}
                            />
                        </Box>

                        <Box sx={{ flex: 1 }}>
                            <TextField
                                label="Container"
                                value={formData[0].container}
                                onChange={(e) => handleChange(0, 'container', e.target.value)}
                                fullWidth
                                error={!!errors.container}
                                helperText={errors.container}
                                sx={{
                                    marginTop: 1,
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: errors.container ? 'error.main' : colors.primary,
                                        },
                                    },
                                }}
                            />
                        </Box>
                    </Box>
                    <Box sx={{ display: 'flex', gap: 2, marginTop: 1, }}>
                        <Box sx={{ flex: 1 }}>
                            <DatePicker
                                label="Ex-Factory Date"
                                value={formData[0].ex_factory}
                                onChange={(date) => handleChange(0, 'ex_factory', date)}
                                slotProps={{
                                    textField: {
                                        error: !!errors.ex_factory,
                                        helperText: errors.ex_factory,
                                        fullWidth: true
                                    }
                                }}
                                sx={{

                                    width: '100%',
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: errors.ex_factory ? 'error.main' : colors.primary,
                                        },
                                    },
                                }}
                            />
                        </Box>

                        <Box sx={{ flex: 1 }}>
                            <DatePicker
                                label="Ship Date"
                                value={formData[0].ship_date}
                                onChange={(date) => handleChange(0, 'ship_date', date)}
                                slotProps={{
                                    textField: {
                                        error: !!errors.ship_date,
                                        helperText: errors.ship_date,
                                        fullWidth: true
                                    }
                                }}
                                sx={{
                                    width: '100%',
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: errors.ship_date ? 'error.main' : colors.primary,
                                        },
                                    },
                                }}
                            />
                        </Box>

                        <Box sx={{ flex: 1 }}>
                            <DatePicker
                                label="Arrival Date"
                                value={formData[0].arrival}
                                onChange={(date) => handleChange(0, 'arrival', date)}
                                slotProps={{
                                    textField: {
                                        error: !!errors.arrival,
                                        helperText: errors.arrival,
                                        fullWidth: true
                                    }
                                }}
                                sx={{
                                    width: '100%',
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: errors.arrival ? 'error.main' : colors.primary,
                                        },
                                    },
                                }}
                            />
                        </Box>
                    </Box>
                </Box>
                {formData.map((form, formIndex) => (
                    <Box key={formIndex} sx={{ mt: 4, mb: 2, position: 'relative' }}>
                        <Typography variant="h6" sx={{ mb: 2 }}>
                            Packing Form {formIndex + 1}
                            {formIndex > 0 && (
                                <IconButton
                                    onClick={() => handleRemoveForm(formIndex)}
                                    sx={{ position: 'absolute', right: 0, top: 0 }}
                                >
                                    <DeleteIcon />
                                </IconButton>
                            )}
                        </Typography>

                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                            <Box sx={{ display: 'flex', gap: 2 }}>
                                <CustomSelect
                                    label="P-Style/Style"
                                    value={form.p_style}
                                    onChange={(e) => handleItemChange(formIndex, 0, 'p_style', e.target.value)}
                                    options={pStyles?.map((ps) => ({ id: ps._id, name: ps.name })) || []}
                                    fullWidth
                                />
                                {/* new stuff */}
                                <IconButton
                                    onClick={() => handleOpenAddRecordDialog('pStyle')}
                                    sx={{
                                        backgroundColor: colors.primary,
                                        '&:hover': { backgroundColor: colors.primary, opacity: 0.9 }
                                    }}
                                >
                                    <Tooltip title="Add PStyle">
                                        <AddIcon sx={{ color: 'black', fontSize: 22 }} />
                                    </Tooltip>
                                </IconButton>

                                <IconButton
                                    onClick={() => handleOpenManagementDialog('pStyle')}
                                    sx={{

                                        backgroundColor: colors.primary,
                                        '&:hover': {
                                            backgroundColor: colors.primary,
                                            opacity: 0.9
                                        }
                                    }}
                                >
                                    <Tooltip title="Management">
                                        <SettingsIcon sx={{ color: 'black', fontSize: 22 }} />
                                    </Tooltip>
                                </IconButton>
                                {/* end new stuff */}
                                {/* <CustomSelect
                                    label="Style"
                                    value={form.style}
                                    onChange={(e) => handleItemChange(formIndex, 0, 'style', e.target.value)}
                                    options={styles?.map((s) => ({ id: s._id, name: s.name })) || []}
                                    fullWidth
                                /> */}
                                {/* new stuff */}
                                {/* <IconButton
                                    onClick={() => handleOpenAddRecordDialog('style')}
                                    sx={{
                                        backgroundColor: colors.primary,
                                        '&:hover': { backgroundColor: colors.primary, opacity: 0.9 }
                                    }}
                                >
                                    <Tooltip title="Add Style">
                                        <AddIcon sx={{ color: 'black', fontSize: 22 }} />
                                    </Tooltip>
                                </IconButton> */}

                                {/* <IconButton
                                    onClick={() => handleOpenManagementDialog('style')}
                                    sx={{

                                        backgroundColor: colors.primary,
                                        '&:hover': {
                                            backgroundColor: colors.primary,
                                            opacity: 0.9
                                        }
                                    }}
                                >
                                    <Tooltip title="Management">
                                        <SettingsIcon sx={{ color: 'black', fontSize: 22 }} />
                                    </Tooltip>
                                </IconButton> */}
                                <TextField
                                    label="Order No"
                                    value={form?.order_no}
                                    onChange={(e) => handleItemChange(formIndex,0, 'order_no', e.target.value)}
                                    error={!!errors.order_no}
                                    helperText={errors.order_no}
                                    sx={{
                                        marginTop: 1,
                                        '& .MuiOutlinedInput-root': {
                                            '& fieldset': {
                                                borderColor: errors.lot ? 'error.main' : colors.primary,
                                            },
                                        },
                                    }}
                                />
                                {/* end new stuff */}
                                <CustomSelect
                                    label="Item"
                                    value={form.item}
                                    sx={{ minWidth: 200 }}
                                    onChange={(e) => handleItemChange(formIndex, 0, 'item', e.target.value)}
                                    options={itemsList?.map((i) => ({ id: i._id, name: i.name })) || []}
                                    fullWidth
                                />
                                {/* new stuff */}
                                <IconButton
                                    onClick={() => handleOpenAddRecordDialog('item')}
                                    sx={{
                                        backgroundColor: colors.primary,
                                        '&:hover': { backgroundColor: colors.primary, opacity: 0.9 }
                                    }}
                                >
                                    <Tooltip title="Add Item">
                                        <AddIcon sx={{ color: 'black', fontSize: 22 }} />
                                    </Tooltip>
                                </IconButton>

                                <IconButton
                                    onClick={() => handleOpenManagementDialog('item')}
                                    sx={{

                                        backgroundColor: colors.primary,
                                        '&:hover': {
                                            backgroundColor: colors.primary,
                                            opacity: 0.9
                                        }
                                    }}
                                >
                                    <Tooltip title="Management">
                                        <SettingsIcon sx={{ color: 'black', fontSize: 22 }} />
                                    </Tooltip>
                                </IconButton>
                                {/* end new stuff */}
                            </Box>

                            <PackingItemsTable
                                items={form.items}
                                handleItemChange={(itemIndex, field, value) => {
                                    handleItemChange(formIndex, itemIndex, field, value);
                                }}
                                handleRemoveItem={(itemIndex) => handleRemoveItem(formIndex, itemIndex)}
                                formIndex={formIndex}
                                errors={errors}
                            />
                        </Box>
                    </Box>
                ))}


                <Box sx={{ mt: 3, p: 2, border: '1px solid #e0e0e0', borderRadius: 1, backgroundColor: '#f5f5f5' }}>
                    <Typography variant="h6" sx={{ mb: 2 }}> Summary</Typography>
                    <Box sx={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                        <Box>
                            <Typography variant="subtitle2" color="text.secondary">Total Pieces</Typography>
                            <Typography variant="h6">
                                {formData.reduce((sum, form) =>
                                    sum + form.items.reduce((itemSum, item) => itemSum + (item.total_pieces || 0), 0), 0)}
                            </Typography>
                        </Box>
                        <Box>
                            <Typography variant="subtitle2" color="text.secondary">Total Boxes</Typography>
                            <Typography variant="h6">
                                {formData.reduce((sum, form) =>
                                    sum + form.items.reduce((itemSum, item) => itemSum + (item.total_box || 0), 0), 0)}
                            </Typography>
                        </Box>
                        {sizes.map(size => (
                            <Box key={size}>
                                <Typography variant="subtitle2" color="text.secondary">Total {size}</Typography>
                                <Typography variant="h6">
                                    {formData.reduce((sum, form) =>
                                        sum + form.items.reduce((itemSum, item) => {
                                            const sizeData = item.sizes.find(s => s.size === size);
                                            return itemSum + (sizeData?.quantity || 0);
                                        }, 0), 0)}
                                </Typography>
                            </Box>
                        ))}
                    </Box>
                </Box>

                <Button
                    variant="outline"
                    startIcon={<AddIcon />}
                    onClick={handleAddForm}
                    fullWidth
                    sx={{ mt: 3, backgroundColor: colors.primary }}
                >
                    Add Another Item
                </Button>

            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button
                    onClick={handleSubmit}
                    variant="contained"
                    sx={{
                        backgroundColor: colors.primary,
                        color: 'black',
                        '&:hover': {
                            backgroundColor: colors.primary,
                            opacity: 0.9,
                        },
                    }}
                >
                    {editData ? 'Update' : 'Submit'}
                </Button>
            </DialogActions>
            {/* new stuff */}
            <Dialog open={addRecordDialog.open} onClose={handleCloseAddRecordDialog}>
                <DialogTitle>Add New {addRecordDialog.type}</DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                        {/* Show customer select only for party */}
                        {addRecordDialog.type === 'party' && (
                            <CustomSelect
                                label="Customer"
                                value={addRecordDialog.customer}
                                onChange={(e) => setAddRecordDialog(prev => ({ ...prev, customer: e.target.value }))}
                                options={customers?.map(customer => ({
                                    id: customer._id,
                                    name: customer.name
                                }))}
                                fullWidth
                            />
                        )}
                        {/* Show party select only for style, pStyle, and item */}
                        {['style', 'pStyle', 'item'].includes(addRecordDialog.type) && (
                            <CustomSelect
                                label="Party"
                                value={addRecordDialog.party}
                                onChange={(e) => setAddRecordDialog(prev => ({ ...prev, party: e.target.value }))}
                                options={parties.map(party => ({
                                    id: party._id,
                                    name: party.name
                                }))}
                                fullWidth
                            />
                        )}
                        <TextField
                            autoFocus
                            label="Name"
                            type="text"
                            fullWidth
                            value={addRecordDialog.name}
                            onChange={(e) => setAddRecordDialog(prev => ({ ...prev, name: e.target.value }))}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseAddRecordDialog}>Cancel</Button>
                    <Button
                        onClick={handleAddRecord}
                        sx={{
                            backgroundColor: colors.primary,
                            color: 'black',
                            '&:hover': {
                                backgroundColor: colors.primary,
                                opacity: 0.9
                            }
                        }}
                    >
                        Add
                    </Button>
                </DialogActions>
            </Dialog>
            {/* till here */}
            {/* new stuff */}
            {/* Add Record Dialog */}
            <Dialog open={addRecordDialog.open} onClose={handleCloseAddRecordDialog}>
                <DialogTitle>Add New {addRecordDialog.type}</DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                        {/* Show customer select only for party */}
                        {addRecordDialog.type === 'party' && (
                            <CustomSelect
                                label="Customer"
                                value={addRecordDialog.customer}
                                onChange={(e) => setAddRecordDialog(prev => ({ ...prev, customer: e.target.value }))}
                                options={customers?.map((item) => ({
                                    id: item?.customer?._id,
                                    name: item?.customer?.name,
                                }))}
                                fullWidth
                            />
                        )}
                        {/* Show party select only for style, pStyle, and item */}
                        {['style', 'pStyle', 'item'].includes(addRecordDialog.type) && (
                            <CustomSelect
                                label="Party"
                                value={addRecordDialog.party}
                                onChange={(e) => setAddRecordDialog(prev => ({ ...prev, party: e.target.value }))}
                                options={parties.map(party => ({
                                    id: party._id,
                                    name: party.name
                                }))}
                                fullWidth
                            />
                        )}
                        <TextField
                            autoFocus
                            label="Name"
                            type="text"
                            fullWidth
                            value={addRecordDialog.name}
                            onChange={(e) => setAddRecordDialog(prev => ({ ...prev, name: e.target.value }))}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseAddRecordDialog}>Cancel</Button>
                    <Button
                        onClick={handleAddRecord}
                        sx={{
                            backgroundColor: colors.primary,
                            color: 'black',
                            '&:hover': {
                                backgroundColor: colors.primary,
                                opacity: 0.9
                            }
                        }}
                    >
                        Add
                    </Button>
                </DialogActions>
            </Dialog>
            <ManagementDialog
                open={managementDialogOpen}
                onClose={() => setManagementDialogOpen(false)}
                type={managementType}
                partyId={formData[0]?.party}
            />
        </Dialog>
    );
};

export default AddPackingListModal;
